<template>
    <div>
        <v-layout wrap justify-center align-center>
            <v-flex md7 sm7 xs12>
                <dialogos-app :dialogos="dialogos" tucan="0" :adelanteVisible="mostrarAdelante" @update:currentText="currentText = $event"></dialogos-app>
            </v-flex>
        </v-layout>
        <!-- primer contenido -->
        <v-layout wrap row pb-5 justify-center align-center class="cont_page animated fadeIn dura-1" v-if="contenido == 1">
          <v-flex xs11 sm7 md7 mb-2 text-xs-center mt-3>
            <button @click="openModalB()" class="button-lectura" :class="{'btnexpandvisto':book}">
              <img src="@/assets/imagenes_compartidas/lectura.svg" alt="">
            </button>
          </v-flex>
        </v-layout>
        <!-- segundo contenido -->
        <v-layout wrap row pb-5 justify-center align-center class="cont_page animated fadeIn dura-1" v-if="contenido == 2">
          <v-flex xs11 sm7 md7 mb-2 text-xs-center>
              <button class="hvr-scale letra-button" v-for="b in 6" :key="'lt'+b" 
              @click="openModal(b)" :class="{'letra-correcta':modalCorrecto[b-1]}">
                  <h3 class="t-blue">{{b}}</h3>
              </button>
          </v-flex>
        </v-layout>
        <!-- modal para primer contenido -->
        <modal-app v-model="modalB" :fullscreen="true" :mostrarCerrar="verCerrar" @pausarAudio="pausarAudio(0)" @click="modalAction()" >
            <template slot="modaltittle">
                <span class="modal-icon-title">
                    <button class="btn-blue-dark" @click="$refs.audioPlayer.playAudio(0)">
                      <span>Clique para escutar <v-icon color="white">headset</v-icon></span>
                    </button>
                </span>
            </template>
            <v-layout row wrap justify-center align-center>
              <v-flex xs12 sm7 md7 mb-2 mt-2 class="cont-texto text-md-center">
                  <h2>Uma pessoa mais velha deve sempre ser tratada por senhor(a) ou pode ser chamada de você?</h2>
                  <p>A verdade é que há casos e casos. Hoje em dia, as pessoas têm horror de serem consideradas velhas; um tratamento mais cerimonioso pode ser até ofensivo. Há quem, até hoje, chame os pais de senhor, como sinal de respeito, hábito que caiu em desuso nos grandes centros urbanos, mas que ainda funciona em alguns lugares. Vivemos num mundo muito mais informal do que foi até metade do século passado. O mais correto é dirigir-se às pessoas mais velhas por senhor ou senhora, e mudar o tratamento se elas pedirem para serem chamadas de você. Para não errar, é só prestar atenção em como elas são tratadas pelas pessoas em volta. É uma boa maneira de se comportar, principalmente nas relações de trabalho. Em geral, as pessoas mais modernas e atualizadas gostam de ser chamadas de você. Em todo caso, o melhor é deixar que elas mesmas sinalizem suas preferências para não parecer que se está comportando muito informalmente e buscando uma intimidade equivocada.
                  </p>
              </v-flex>
            </v-layout>
        </modal-app>
      <!-- modal segundo contenido -->
        <modal-app v-model="modal" :fullscreen="true">
            <template slot="modaltittle">
              <h1 class="modal-icon-title"></h1>
            </template>
            <v-layout row wrap justify-center align-center>
              <v-flex xs12 md7 sm7 class="cont-titulo">
                <p>{{modalTitulo[tituloNum]}}</p>
              </v-flex>
              <v-flex xs12 md7 sm7 mt-4>
                <button class="btn-comprobar hvr-scale hvr" 
                @click="comprobar(valueVoce)"><span>Você</span></button>
              </v-flex>
              <v-flex xs12 md7 sm7 mt-4>
                <button class="btn-comprobar hvr-scale hvr" 
                @click="comprobar(valueSenhor)"><span>Senhor (a)</span></button>
              </v-flex>
              <v-flex xs12 md7 sm7 mt-4>
                <button class="btn-comprobar hvr-scale hvr" 
                @click="comprobar(valueVoceSenhor)"><span>Você/Senhor (a)</span></button>
              </v-flex>
            </v-layout>
        </modal-app>
        <!-- modal Resultado -->
        <modal-resultado-app v-model="modalresultado" :nameResult="modalResult" :fullscreen="true" @bienAvanzar="bienAction()">
        </modal-resultado-app>
        <audio-player ref="audioPlayer" :autoplay="false" :audios="['Lecturas/Uma pessoa mais velha deve sempre ser']"></audio-player>
    </div>
</template>
<script>
import nextConditions from "../../js/mixins/nextConditions";
export default {
  mixins: [nextConditions],
  data() {
    return {
      dialogos: [
        'Leia o texto que aparece na tela.',
        'Selecione a opção "Senhor" ou "você" depois de ler a frase destacada. Quando terminar, clique em avançar.'
      ],
      currentText:0,
      contenido:1,
      modalB:false,
      modal:false,
      modalCorrecto:Array(6).fill(false),
      modalTitulo:[
        'Na rua, um jovem fala com um desconhecido de 60 anos.',
        'No escritório, um rapaz fala com um colega jovem.',
        'No tribunal de justiça, um jovem fala com um juiz de direito de 30 anos.',
        'Um neto com a avó.',
        'Professora de 25 anos.',
        'Secretária de 60.'
      ],
      tituloNum:0,
      modalresultado:false,
      modalResult:'bien',
      valueVoce:'bien',
      valueSenhor:'mal',
      valueVoceSenhor:'mal',
      vistos:Array(6).fill(false),
      book:false,
      mostrarAdelante:false,
    }
  },
  methods: {
    openModalB(){
      this.modalB = true
      this.book = true
      this.mostrarAdelante = true
    },
    openModal(val){
      this.modal = true
      this.tituloNum = val-1
      switch (val) {
        case 1:
          this.valueVoce = 'mal'
          this.valueSenhor = 'bien'
          this.valueVoceSenhor = 'mal'
          break;
        case 2:
          this.valueVoce = 'bien'
          this.valueSenhor = 'mal'
          this.valueVoceSenhor = 'mal'
          break;
        case 3:
          this.valueVoce = 'mal'
          this.valueSenhor = 'bien'
          this.valueVoceSenhor = 'mal'
          break;
        case 4:
          this.valueVoce = 'mal'
          this.valueSenhor = 'mal'
          this.valueVoceSenhor = 'bien'
          break;
        case 5:
          this.valueVoce = 'bien'
          this.valueSenhor = 'mal'
          this.valueVoceSenhor = 'mal'
          break;
        case 6:
          this.valueVoce = 'mal'
          this.valueSenhor = 'mal'
          this.valueVoceSenhor = 'bien'
          break;
        default:
          this.valueVoce = 'mal'
          this.valueSenhor = 'bien'
          this.valueVoceSenhor = 'mal'
      }
    },
    comprobar(val){
      this.modalresultado= true
      this.modalResult = val
    },
    bienAction(){
      this.$set(this.modalCorrecto,this.tituloNum,true)
      this.modal = false
      this.$set(this.vistos,this.tituloNum,true)
    },
    pausarAudio(){
      console.log("audio pausado")
      this.$refs.audioPlayer.pauseAudio(0)
    }
  },
  watch: {
    currentText(val){
      if(val == 0){
        this.contenido = 1
      }else if(val == 1){
        this.contenido = 2
      }

    }
  },
}
</script>
<style lang="scss" scoped>
// NOT SCOPED !!
@import '../../sass/globals';
.cont-texto{
  h2{
    margin: 0;
    padding: 0;
    font-family: Poppins-Bold;
    font-size: 14px;
  }
  p{
    margin: 0;
    padding: 0;
    font-family: Poppins-Regular;
    font-size: 14px;
    text-align: left;
    margin-top: 10px;
  }
}

.letra-button{
  border: solid $ibra-dark-blue;
  width: 70px;
  height: 70px;
  margin: 8px;
  border-radius: 20px;
  background: $ibra-dark-blue;
  .t-blue{
    color: white;
    font-family:Poppins-Bold;
    font-size: 35px;
    margin: 0;
    padding: 0;
    line-height: 0;
  }
}
.letra-correcta{
  background: #368735;
}
.cont-titulo{
  color: #00569F;

  p{
    font-family: Poppins-Bold;
    font-size: 18px;
  }
}
.btn-comprobar{
  border: solid $ibra-dark-blue 4px;
  border-radius: 40px;
  width: 200px;
  height: 80px;
  background: white;
  color: #000C1A;
  font-family: Poppins-Bold;
  font-size: 18px;
}
.bien{
  background: green;
}
.mal{
  background: orange;
}

</style>
